import { configureStore } from '@reduxjs/toolkit';
import personalReducer from './personalSlice';
import themeReducer from './themeSlice';
import skillReducer from './skillSlice';
import languageReducer from './languageSlice'
import experienceReducer from './experienceSlice'
import courseReducer from './courseSlice'
import linkReducer from './linkSlice'
import hobbyReducer from './hobbySlice'
import paymentReducer from './paymentSlice'

const store = configureStore({
  reducer: {
    personal: personalReducer,
    themeSlice: themeReducer,
    skillSlice: skillReducer,
    languageSlice: languageReducer,
    experienceSlice: experienceReducer,
    courseSlice: courseReducer,
    linkSlice: linkReducer,
    hobbySlice: hobbyReducer,
    paymentSlice: paymentReducer
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;


